import React from 'react';
import ReactDOM from 'react-dom';
import { HttpClient } from '@sentry/integrations';
import '@careerhub/chubby/scss/main.scss';
import { BrowserTracing, Replay, init } from '@sentry/react';
import App from './App';
import './index.scss';

init({
    dsn: 'https://0438b84b23c14bceb2908a83e99a40eb@errors.careerhub.support/32',
    release: process.env.SENTRYUIRELEASE,
    environment: (() => {
        const hostname = window.location.hostname;
        if (hostname === 'staging.reports.bond.careerhub.com.au') {
            return 'Staging';
        }
        if (hostname === 'reports.bond.careerhub.com.au') {
            return 'Production';
        }
        return 'Development';
    })(),
    integrations: [
        new BrowserTracing(),
        new Replay({
            maskAllText: true,
            blockAllMedia: true
        }),
        new HttpClient()
    ],
    tracesSampleRate: 0.1, // track 10% of transactions
    // only record sessions if an error has occured
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0
});

ReactDOM.render(
    <App />,
    document.getElementById('root')
);
